import { render, staticRenderFns } from "./DistributeDetails.vue?vue&type=template&id=7bb4eb64&scoped=true"
import script from "./DistributeDetails.vue?vue&type=script&lang=js"
export * from "./DistributeDetails.vue?vue&type=script&lang=js"
import style0 from "./DistributeDetails.vue?vue&type=style&index=0&id=7bb4eb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb4eb64",
  null
  
)

export default component.exports